<template>
  <div>
    <router-view></router-view>
    <create-card route_back="ClientList" model_name="cliente" :saving="saving" :loading="loading.checking_client">
      <template slot="form">
        <ClientInfoStepper class="pa-1" ref="form0" @saveClient="handleSaveClient" :client="client"></ClientInfoStepper>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapActions, mapState, mapGetters } from 'vuex'


export default {
  name:"CreateClient",

  components:{
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    ClientInfoStepper: () => import("./steppers/ClientInfoStepper.vue"),
    ClientCreditsAndLimitStepper: () => import("./steppers/ClientCreditsAndLimitStepper"),
    ClientShippingAddressStepper: () => import("./steppers/ClientShippingAddressStepper.vue"),
    StepperManyContacts: () => import("@/_backoffice/_registrations/components/shared/forms/steppers/StepperManyContacts.vue"),
    StepperAddress: () => import("@/_backoffice/_registrations/components/shared/forms/steppers/StepperAddress.vue"),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
  },
  data() {
    return {
      stepper: 0,
      saving:false,
      loading: {
        checking_client: false,
      },
      client: {
        place_id: null,
        modality_ids:[],
        status_id: 1,
        type: 'Pessoa Jurídica',
        fantasyName: '',
        corporateName: '',
        CNPJ: '',
        CPF: '',
        name: '',
        attachment_attributes: null,
        employee_id: null, 
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
        client_credit_attributes: {
          limit_aux: 0,
          limit: 0,
          original_limit: 0,
          blockingTime: 0,
          status_id: 1,
        },
      },
    }
  },
  computed:{
    is_cnpj(){
      return this.client.fantasyName != '' && this.client.fantasyName != null
    },
  },
  methods: {
    checkClientDocument(){
      this.loading.checking_client = true

      let document = (!this.is_cnpj ? this.client.CPF : this.client.CNPJ).toString().replace(/[\W]/g, "")
      Api.Client.indexByDocument(document).then(req => req.data).then(data => {
        if(data?.[0]?.id != null){
          this.stepper = 0
          this.$router.push({name: 'ClientExist', params: {id: data?.[0]?.id}})
        }else{
          this.submitClient()
        }
      }).finally(()=>{
        this.loading.checking_client = false
      })
    },
    handleSaveClient(){
      if(this.$refs[`form${this.stepper}`].validate()){
        this.checkClientDocument()
      }else{
        this.addNotification({type: 'error',  msg: `Humm.. Alguns campos são necessários.`})
      }
    },
    prepareClient(){
      let new_name = this.is_cnpj ? this.client.fantasyName : this.client.name
      this.client.name = new_name
      this.client.corporateName = new_name
      this.client.fantasyName = new_name

      let {place_id, ...rest} = this.client
      let client = {...rest, modality_ids: [place_id]}
      return client
    },
    submitClient() {
      this.swallConfirmation({
        title: `Deseja cadastrar cliente?`,
        icon: 'question',
      }).then( confirmed =>{
        if ( confirmed ) {
          let client = this.prepareClient()
          this.saving = true

          Api.Client.create(client).then(res => {
            this.addNotification({type: 'success',  msg: `Cliente cadastrado com sucesso!`})
            setTimeout(() => {
              this.$router.push({name:"ShowClient", params:{id: res.data.id} })
            }, 1000);
          }).catch(er => {
            this.addNotification({type: 'error',  msg: er})
          }).finally(() => {
            this.saving = false 
            this.$router.push({name: 'ClientList'})
          })
        }
      })
    },
    resetClient(){
      let backup_depots = this.client.modality_ids
      this.client = {
        modality_ids: backup_depots,
        status_id: 1,
        type: 'Pessoa Jurídica',
        fantasyName: '',
        corporateName: '',
        CNPJ: '',
        CPF: '',
        name: null,
        attachment_attributes: null,
        employee_id: null, 
        stateEnrollment: '',
        lastSPC: '',
        fileSPC: '',
        observation: '',
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
        contact_attributes: [],
        shippingAddress: {
          num1: null,
          num2: null,
          num3: null,
          num4: null,
          primary: {
            zip: '',
            city: '',
            complement: '',
            neighborhood: '',
            addr: '',
            uf: '',
            number: '',
          },
          secondary: {
            zip: '',
            city: '',
            complement: '',
            neighborhood: '',
            addr: '',
            uf: '',
            number: '',
          },
          third: {
            zip: '',
            city: '',
            complement: '',
            neighborhood: '',
            addr: '',
            uf: '',
            number: '',
          },
          fourth: {
            zip: '',
            city: '',
            complement: '',
            neighborhood: '',
            addr: '',
            uf: '',
            number: '',
          },
        },
        address: {
          zip: '',
          city: '',
          complement: '',
          neighborhood: '',
          addr: '',
          uf: '',
        },
        contacts: {
          primary: {
            name: '',
            position: '',
            email: '',
            telephone: '',
            celphone: '',
            comment: '',

          },
          secondary: {
            name: '',
            position: '',
            email: '',
            telephone: '',
            celphone: '',
            comment: '',

          },
          third: {
            name: '',
            position: '',
            email: '',
            telephone: '',
            celphone: '',
            comment: '',

          },
          fourth: {
            name: '',
            position: '',
            email: '',
            telephone: '',
            celphone: '',
            comment: '',

          },
          fifth: {
            name: '',
            position: '',
            email: '',
            telephone: '',
            celphone: '',
            comment: '',

          },
        },
        addresses_attributes: {
          addr: null,
          number: '',
          complement: '',
          city: null,
          state: null,
          zip: '',
          neighborhood: null,
        },
        client_credit_attributes: {
          limit_aux: null,
          limit: null,
          original_limit: null,
          blockingTime: null,
          status_id: 1,
        },
        shipping_addresses_attributes: [],

      }
      this.stepper = 0
    },
  },
  watch: {
    stepper(nv) {
      if( nv == 1) {
        this.checkClientDocument()
        this.$refs.form4.getEmployees()
      }
    },

  },
}
</script>

